import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    CounterpartyAddressesColumn,
    CounterpartyAddressesView,
} from "@common/types/views/counterpartyAddressesView";
import {
    CounterpartyContactsColumn,
    CounterpartyContactsView,
} from "@common/types/views/counterpartyContactsView";

export function createCounterpartyContactsView(): CounterpartyContactsView {
    return {
        type: ViewType.COUNTERPARTY_CONTACTS,
        columns: [
            { id: CounterpartyContactsColumn.NAME },
            { id: CounterpartyContactsColumn.EMAIL },
            { id: CounterpartyContactsColumn.PHONE },
            { id: CounterpartyContactsColumn.PRIMARY },
            {
                id: CounterpartyContactsColumn.ACTIONS,
                options: { pin: "right" },
            },
        ],
        filters: {},
        options: { density: ViewDensity.SM },
    };
}

export function createCounterpartyAddressesView(): CounterpartyAddressesView {
    return {
        type: ViewType.COUNTERPARTY_ADDRESSES,
        columns: [
            { id: CounterpartyAddressesColumn.ADDRESS },
            { id: CounterpartyAddressesColumn.LABEL },
            { id: CounterpartyAddressesColumn.PRIMARY },
            {
                id: CounterpartyAddressesColumn.ACTIONS,
                options: { pin: "right" },
            },
        ],
        filters: {},
        options: { density: ViewDensity.SM },
    };
}
